import AdminInviteVerify from './AdminInviteVerify'
import enhance from './AdminInviteVerify.enhancer'

export default enhance(AdminInviteVerify)



// WEBPACK FOOTER //
// ./src/containers/invitations/AdminInviteVerify/index.js